<header class="complex-list-header">
  <div class="complex-list-header__header">
    <div class="complex-list-header__title-status">
      <h1 class="complex-list-header__title">{{ title }}</h1>
      @if (statusTypeConfig && tabs) {
        <div
          class="complex-list-header__status-type"
          [ngClass]="'complex-list-header__status-type--' + headerSectionConfig.floatingTabsVisibility"
        >
          <ftr-complex-list-status-type [tabs]="tabs" [config]="statusTypeConfig"></ftr-complex-list-status-type>
        </div>
      }
    </div>
    <div
      class="complex-list-header__filter"
      [ngClass]="'complex-list-header__filter--' + headerSectionConfig.filterButtonVisibility"
    >
      <ng-container *ngTemplateOutlet="additionalButtonsTemplate"></ng-container>
      <ng-container *ngTemplateOutlet="filterToggleButton"></ng-container>
    </div>
  </div>
  <div class="complex-list-header__sort-pagination">
    <div class="complex-list-header__sort">
      @if (sortConfig) {
        <ftr-complex-list-sort
          [config]="sortConfig"
          [sortDirectionText]="sortDirectionText"
          [sortByDropdownHeaderSize]="headerSectionConfig.sortByDropdownHeaderSize"
        ></ftr-complex-list-sort>
      }
    </div>
    @if (meta && meta.totalItems > meta.size) {
      <ftr-pagination class="complex-list-header__pagination" [meta]="meta!" [disabled]="isLoading"> </ftr-pagination>
    }
    @if (meta && meta.totalItems <= meta.size && meta.totalItems > 0) {
      <span class="complex-list-header__pagination">
        {{ meta.totalItems }} {{ entityName | titlecase }}{{ meta.totalItems > 1 ? 's' : '' }}
      </span>
    }
  </div>
</header>

<ng-template #filterToggleButton>
  @if ({ value: (toggled | async) || false }; as filtersOn) {
    <!-- A button doesn't change its color once rendered, so we use two -->
    @if (!filtersOn.value) {
      <button
        ftrButton
        data-track
        class="complex-list-header__filter-toggle"
        [color]="buttonColor.Secondary"
        (click)="toggleFilters(filtersOn.value)"
        [flexLayout]="true"
      >
        <ng-container *ngTemplateOutlet="buttonContent; context: { badgeType: badgeType.Secondary }"></ng-container>
      </button>
    }
    @if (filtersOn.value) {
      <button
        ftrButton
        data-track
        class="complex-list-header__filter-toggle"
        (click)="toggleFilters(filtersOn.value)"
        [flexLayout]="true"
      >
        <ng-container *ngTemplateOutlet="buttonContent; context: { badgeType: badgeType.Primary }"></ng-container>
      </button>
    }
  }
</ng-template>

<ng-template #buttonContent let-badgeType="badgeType">
  @if (!numberOfAppliedFilters) {
    <ftr-icon class="complex-list-header__filter-icon" icon="FilterList" size="Regular"></ftr-icon>
  }
  @if (numberOfAppliedFilters) {
    <span class="complex-list-header__filter-badge" [class]="'complex-list-header__filter-badge--' + badgeType">
      {{ numberOfAppliedFilters }}
    </span>
  }
  Filters
</ng-template>
